import { render, staticRenderFns } from "./trip-view-page.vue?vue&type=template&id=31308b8e&scoped=true&"
import script from "./trip-view-page.vue?vue&type=script&lang=js&"
export * from "./trip-view-page.vue?vue&type=script&lang=js&"
import style0 from "./trip-view-page.vue?vue&type=style&index=0&id=31308b8e&lang=scss&scoped=true&"
import style1 from "./trip-view-page.vue?vue&type=style&index=1&id=31308b8e&lang=scss&scoped=true&"
import style2 from "./trip-view-page.vue?vue&type=style&index=2&id=31308b8e&lang=scss&scoped=true&"
import style3 from "./trip-view-page.vue?vue&type=style&index=3&id=31308b8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31308b8e",
  null
  
)

export default component.exports
import {QBreadcrumbs,QIcon,QBreadcrumbsEl} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QBreadcrumbs,QIcon,QBreadcrumbsEl})
